import axios from "axios";

/**
 * Thin wrapper around the devops connector endpoints.
 * All routes require the DEVOPS role.
 */
const connectorDevopsService = {
	listConnectors() {
		return axios.get("/connectors/devops").then(r => r.data);
	},

	listOrganizationConnectors() {
		return axios.get("/connectors/devops/organizations").then(r => r.data);
	},

	listSessions(organizationId) {
		return axios
			.get(`/connectors/devops/organizations/${organizationId}/sessions`)
			.then(r => r.data);
	},

	createOrganizationConnector(type, organizationId, payload) {
		return axios
			.post(
				`/connectors/devops/${type}/organizations/${organizationId}`,
				payload
			)
			.then(r => r.data);
	},

	updateOrganizationConnector(type, organizationId, payload) {
		return axios
			.put(
				`/connectors/devops/${type}/organizations/${organizationId}`,
				payload
			)
			.then(r => r.data);
	},

	deleteOrganizationConnector(type, organizationId) {
		return axios
			.delete(`/connectors/devops/${type}/organizations/${organizationId}`)
			.then(r => r.data);
	}
};

export default connectorDevopsService;
